import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/privacy.scss";

const faqGroups = [
  {
    title: "Orders & payment",
    items: [
      ["When is my order confirmed?", "Your order is confirmed after the secure payment page reports a successful transaction. Keep the order reference shown on your confirmation page for any follow-up."],
      ["Which currency do you use?", `All prices and payments are shown in ${siteConfig.currency.code}. Your bank may apply its own conversion or international transaction charge.`],
      ["Can I change an order?", "Contact us as soon as possible. We can only change an order before packing begins, so amendments are not guaranteed."],
    ],
  },
  {
    title: "Products & care",
    items: [
      ["Will colors look exactly the same in person?", "We photograph products in neutral light, but screens and natural material variation can affect how color appears. Leather, linen, brass, and walnut may each develop an individual patina."],
      ["How should I care for my item?", "Keep paper goods dry and store them away from direct sunlight. Wipe desk accessories with a soft dry cloth, and avoid alcohol cleaners or abrasive products."],
      ["How do I choose a planner size?", "Check the size and compatibility details on each product page. If you already own a cover, compare its ring spacing and page measurements before ordering inserts."],
    ],
  },
  {
    title: "Delivery & returns",
    items: [
      ["How much is shipping?", `Standard shipping is ${new Intl.NumberFormat(siteConfig.currency.locale, { style: "currency", currency: siteConfig.currency.code }).format(siteConfig.shipping.standardRate)} per order.`],
      ["Where do you deliver?", `We deliver to ${siteConfig.shipping.destinations}. Available destinations are listed at checkout; restricted destinations do not appear.`],
      ["Can I return an item?", `Eligible unused goods may be requested for return within ${siteConfig.shipping.returnsWindowDays} days. See the returns policy for condition and exclusion details.`],
    ],
  },
];

function Faqs() {
  return (
    <main className="privacy-page policy-page" id="main-content">
      <header className="policy-hero">
        <p className="policy-eyebrow">Customer care</p>
        <h1>Frequently asked questions</h1>
        <p className="policy-intro">Clear answers about ordering, product care, delivery, and returns from {siteConfig.brandName}.</p>
      </header>
      <div className="policy-layout">
        <aside className="policy-toc">
          <nav aria-label="On this page"><p>On this page</p><ol>{faqGroups.map((group, index) => <li key={group.title}><a href={`#faq-${index + 1}`}>{group.title}</a></li>)}</ol></nav>
        </aside>
        <article className="policy-content">
          {faqGroups.map((group, index) => (
            <section id={`faq-${index + 1}`} key={group.title}>
              <span className="policy-section-number">{String(index + 1).padStart(2, "0")}</span>
              <h2>{group.title}</h2>
              {group.items.map(([question, answer]) => <details key={question}><summary>{question}</summary><p>{answer}</p></details>)}
            </section>
          ))}
          <nav className="policy-related" aria-label="Related customer care pages"><p>Still need help?</p><div><Link to="/contact">Contact us <span aria-hidden="true">&rarr;</span></Link><Link to="/shipping">Shipping information <span aria-hidden="true">&rarr;</span></Link><Link to="/returns">Returns &amp; exchanges <span aria-hidden="true">&rarr;</span></Link></div></nav>
        </article>
      </div>
    </main>
  );
}

export default Faqs;
